import { Fragment } from 'react'
import { connect } from 'react-redux'
import store from 'app/store'

const USER_STUB = { permissions: [], role: null };
const MARTIX = { read: 1, write: 2, exec: 4 };
const checkPermission = (permission, level, p) => (p.key === permission) && ((p.level & MARTIX[level]) == MARTIX[level]);
const withPermission = (user, permission, level) => (user.role === 'ADMIN') || user.permissions.findIndex(checkPermission.bind(null, permission, level)) !== -1;

export const hasPermissionFor = (permission, level) => {
  let user = store.getState().auth.user || USER_STUB;
  return withPermission(user, permission, level);
}

const mapStateToProps = (state, props) => {
  let user = (state.auth.user || USER_STUB);
  let isAllowed;
  if(props.role) {
    isAllowed = user.role === props.role;
  } else {
    isAllowed = withPermission(user, props.permission, props.level);
  }
  return { isAllowed };
}

const Guard = ({ isAllowed, children }) => isAllowed ? <Fragment>{children}</Fragment> : null;

export default connect(mapStateToProps)(Guard);
